import { Button, Flex } from 'antd'
import { useState } from 'react'

import { useTreatmentServiceGetActiveList } from 'src/api/queries'
import { Text } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import { NewCasesModal } from './NewCasesModal'
import { useStyles } from './styles'

export const NewCasesCard = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { userData } = useUser()

  const [isOpen, setIsOpen] = useState(false)

  const { data } = useTreatmentServiceGetActiveList(
    {
      institutionId: userData?.currentLegalEntityId
    },
    [userData?.currentLegalEntityId]
  )

  const onToggle = () => setIsOpen((prev) => !prev)

  if (!data?.data?.length) return

  return (
    <>
      <Flex className={styles.card} align="center" justify="space-between">
        <Text size="xl" weight={700}>
          {data?.totalCount === 1
            ? t('epidemiology.new_case')
            : t('epidemiology.new_cases', { count: data?.totalCount })}
        </Text>

        <Button type="link" onClick={onToggle}>
          {t('common.see_all_list')}
        </Button>
      </Flex>

      {isOpen && <NewCasesModal onCancel={onToggle} />}
    </>
  )
}
